//Show wait cursor
function PleaseWait() {
    const fancybox = new Fancybox([
        {
            src: "<div class='text-center'><p><img alt='please wait cursor' class='pleaseWaitCursor' src='https://humankinetics.myshopify.com/cdn/shop/files/loading.gif'></img></p><h3 class='accent-color'>Processing Request</h3> <p><strong>Please note that this may take a few minutes.</strong></p></div>",
            type: "html",

        },
    ]);
}

//Hide wait cursor
function HideWait() {
    Fancybox.close();
}

// Display error message modal
function ShowError(errorMsg) {
    const fancybox = new Fancybox([
        {
            src: "<p>" + errorMsg + "</p><p><a class='btn btn--primary' href='#' onClick='HideWait(); return false;'>Close</a></p>",
            type: "html",
            closeButton: true
        },
    ]);
}

//create and return a new div element
function CreateDiv(divContent, columnSize, secondClass) {
    const newDiv = document.createElement("div");
    newDiv.classList.add(columnSize);
    if (secondClass) {
        newDiv.classList.add(secondClass);
    }
    const newContent = document.createTextNode(divContent);
    newDiv.appendChild(newContent);
    return newDiv;
}

//creates certificates upper left content.
function CreateUpperLeftContent(altText, imgUrl, width, height) {
    //create upper left div.
    const upperLeftDiv = document.createElement("div");
    upperLeftDiv.classList.add("upper-content-left");
    upperLeftDiv.innerHTML = '<img alt="' + altText + '" class="ce-logo coachEd-logo" src="'+imgUrl+'" style="width:'+width+'px; height:'+height+'px;" />';
    return upperLeftDiv;
}

//create certificates middle content.
function CreateMiddleContent(custName, courseTitle, longOrgName, ceus, ceuType, providerId) {
	//create middle content div.
	//create header.
	const middleContentDiv = document.createElement("div");
	middleContentDiv.classList.add("middle-content");

	const certHeader = document.createElement("h1");
	const certHeaderTextNode = document.createTextNode("CERTIFICATE OF COMPLETION");
	certHeader.appendChild(certHeaderTextNode);
	middleContentDiv.appendChild(certHeader);

	//document certifies paragraph.
	var certifies = document.createElement('p');
	certifies.innerHTML = "This document certifies that";
	middleContentDiv.appendChild(certifies);

	//learner's name.
	const learnerName = document.createElement("h2");
	learnerName.classList.add("learner");
	const learnerNameTextNode = document.createTextNode(custName);
	learnerName.appendChild(learnerNameTextNode);
	middleContentDiv.appendChild(learnerName);

	var hasCompleted = document.createElement("p");
	hasCompleted.innerHTML = "has successfully completed";
	middleContentDiv.appendChild(hasCompleted);

	const title = document.createElement("h3");
	title.classList.add("title");
	const titleTextNode = document.createTextNode(courseTitle);
	title.appendChild(titleTextNode);
	middleContentDiv.appendChild(title);

	if (ceus) {
		var accreditingBody = document.createElement("p");
		accreditingBody.innerHTML = longOrgName + "<span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>" + ceus + "&nbsp;" + ceuType;
		middleContentDiv.appendChild(accreditingBody);
		if (providerId) {
			if (longOrgName == "Board of Certification for the Athletic Trainer") {
				var accreditingStatement = document.createElement("p");
				accreditingStatement.classList.add("acreditation_stmt");
				accreditingStatement.innerHTML = "Human Kinetics (BOC AP#: P421) is approved by the Board of Certification, Inc. to provide continuing education to Certified Athletic " +
				                             	"Trainers. This program is eligible for the maximum number of Category A hours/CEUs listed on this certificate. ATs should claim " +
				                             	"only those hours actually spent in the educational program.";
				middleContentDiv.appendChild(accreditingStatement);

			} else {
				var accreditingStatement = document.createElement("p");
				accreditingStatement.classList.add("acreditation_stmt");
				accreditingStatement.innerHTML = "Provider Number: " + providerId;
				middleContentDiv.appendChild(accreditingStatement);
			}
		}
	}

	return middleContentDiv;
}

//create certificates lower content.
function CreateLowerContent(testCompletedDate, sigUrl, sigWidth, sigHeight, sigAltText, sigName, sigTitle) {
	//create lower content div.
	const lowerContentDiv = document.createElement("div");
	lowerContentDiv.classList.add("lower-content");

	//create table.
	var table = document.createElement('table');
	table.classList.add('sig-table');

	//create table body.
	var tBody = document.createElement('tbody');

	//create signature row.
	var sigRow = document.createElement('tr');
	sigRow.classList.add("top-row");

	//create signature column.
	var sigCol = document.createElement('td');
	sigCol.setAttribute("style", "width: 45%");
	sigCol.innerHTML = '<img alt="' + sigAltText + '" src="' + sigUrl + '" style="width:' + sigWidth + 'px; height: '+ sigHeight + 'px;" />';
	sigRow.appendChild(sigCol);

	//create middle column.
	var midCol = document.createElement('td');
	midCol.setAttribute('style', "width: 10%");
	midCol.innerHTML = "&nbsp;";
	sigRow.appendChild(midCol);

	//create complete date column.
	var completeDate = document.createElement('td');
	completeDate.setAttribute("style", "width: 45%");
	completeDate.innerHTML = testCompletedDate;
	sigRow.appendChild(completeDate);
	tBody.appendChild(sigRow);

	//create bottom row.
	var bottomRow = document.createElement('tr');
	bottomRow.classList.add('bottom-row');

	//name column.
	var sigNameCol = document.createElement('td');
	sigNameCol.innerHTML = "<p>" + sigName + "<br /><em>" + sigTitle + "</em></p>";
	bottomRow.appendChild(sigNameCol);

	//middle column.
	var bottomMidCol = document.createElement('td');
	bottomMidCol.innerHTML = "&nbsp;";
	bottomRow.appendChild(bottomMidCol);

	//date title.
	var dateTitle = document.createElement('td');
	dateTitle.innerHTML = "<p class='bottom-row'>Completion Date</p>";
	bottomRow.appendChild(dateTitle);

	//append row to table body.
	tBody.appendChild(bottomRow);

	//add body to table.
	table.appendChild(tBody);
	//add table to lower content div
	lowerContentDiv.appendChild(table);

	return lowerContentDiv;
}

